//@ts-nocheck TS6133
/* eslint-disable @typescript-eslint/no-duplicate-imports */
import type * as Types from 'owa-graph-schema';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { BookingWorkHoursFragmentFragmentDoc } from './BookingWorkHoursFragment.interface';
import { BookingPostalAddressFragmentFragmentDoc } from './BookingPostalAddressFragment.interface';
export type BookingBusinessInformationFragmentFragment = {
    __typename?: 'BookingBusinessEntry';
    displayName?: string | null;
    businessType?: string | null;
    phone?: string | null;
    email?: string | null;
    websiteUrl?: string | null;
    defaultCurrencyIso?: string | null;
    currencySymbol?: string | null;
    privacyPolicyUrl?: string | null;
    termsAndConditionsUrl?: string | null;
    customOnlineMeetingUrl?: string | null;
    businessName?: string | null;
    mailboxId?: string | null;
    businessHours?: Array<{
        __typename?: 'BookingWorkHours';
        day?: string | null;
        timeSlots?: Array<{
            __typename?: 'BookingsWorkTimeSlot';
            start?: number | null;
            end?: number | null;
        } | null> | null;
    } | null> | null;
    address?: {
        __typename?: 'BookingPostalAddress';
        name?: string | null;
        street?: string | null;
        city?: string | null;
        state?: string | null;
        countryOrRegion?: string | null;
        postalCode?: string | null;
        postOfficeBox?: string | null;
        locationSource?: Types.BookingLocationSourceType | null;
        type?: string | null;
    } | null;
};
export const BookingBusinessInformationFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'BookingBusinessInformationFragment' },
            typeCondition: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'BookingBusinessEntry' },
            },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'businessType' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'websiteUrl' } },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessHours' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'BookingWorkHoursFragment' },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'BookingPostalAddressFragment' },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'defaultCurrencyIso' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'currencySymbol' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'privacyPolicyUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'termsAndConditionsUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'customOnlineMeetingUrl' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'businessName' } },
                    { kind: 'Field', name: { kind: 'Name', value: 'mailboxId' } },
                ],
            },
        },
        ...BookingWorkHoursFragmentFragmentDoc.definitions,
        ...BookingPostalAddressFragmentFragmentDoc.definitions,
    ],
} as unknown as DocumentNode<BookingBusinessInformationFragmentFragment, unknown>;
